export interface Logger {
    debug(message: string, ...args: any[]): void;
    info(message: string, ...args: any[]): void;
    warn(message: string, ...args: any[]): void;
    error(message: string, ...args: any[]): void;
}

export class ConsoleLogger implements Logger {
    constructor(private readonly enableDebug: boolean = false) {}

    debug(message: string, ...args: any[]): void {
        if (this.enableDebug) {
            console.debug(`[PIAPI Debug] ${message}`, ...args);
        }
    }

    info(message: string, ...args: any[]): void {
        console.info(`[PIAPI Info] ${message}`, ...args);
    }

    warn(message: string, ...args: any[]): void {
        console.warn(`[PIAPI Warn] ${message}`, ...args);
    }

    error(message: string, ...args: any[]): void {
        console.error(`[PIAPI Error] ${message}`, ...args);
    }
} 